import { ref, computed } from 'vue';
import { useStore } from '@/utils/vue-api';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useNavigation } from '@rebuild/hooks/useNavigation';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';

const useCompanyProfile = () => {
	let companyOptions = {
		done: false
	};
	const { company_profile } = useModuleData();

	const loadCompanyInfo = async () => {
		await company_profile.refresh();
		return company_profile.data?.data;
	};

	const initCompanyInfo = async () => {
		let data = await loadCompanyInfo();
		if (data && data.length) {
			let c_config,
				c_own,
				c_summary,
				useConfig = false;

			data.forEach(item => {
				// 自有页面
				if (item.module.id == 'company_own_page') c_own = item;
				// 配置页面
				if (item.module.id == 'company_config_page') c_config = item;
				// 企业简介
				if (item.module.id == 'company_summary') c_summary = item;
			});

			if (c_config) useConfig = true;
			if (c_own) c_own = c_own?.data || {};

			if (useConfig) {
				companyOptions = {
					done: true,
					useConfig: true,
					data: c_summary
				};
			} else {
				companyOptions = {
					done: true,
					useConfig: false,
					data: c_own
				};
			}
		}
	};

	const { viewModule } = useModuleNavigation();
	const goCompany = () => {
		if (!companyOptions) return;
		if (companyOptions.useConfig) {
			viewModule('company_profile', {
				option: companyOptions.data,
				isOwn: false
			});
		} else {
			viewModule('company_profile', {
				option: {
					data: companyOptions.data
				},
				isOwn: true
			});
		}
	};

	return {
		initCompanyInfo,
		goCompany
	};
};

export function useIconGrid() {
	const store = useStore();
	const getIrCoreConfig = computed(() => store.getters.getIrCoreConfig);
	const getIrTemplateFlattenModules = computed(() => store.getters.getIrTemplateFlattenModules);

	const { initCompanyInfo, goCompany } = useCompanyProfile();

	const iconGridList = ref([]);
	const generateGridModules = async () => {
		const includeCompany = getIrCoreConfig.value.find(item => item['moduleId'] === 'company_profile') !== undefined;
		if (includeCompany) {
			await initCompanyInfo();
		}

		const filterGridModules = (getIrCoreConfig.value || [])
			.map(module => {
				return {
					sort: module.sort,
					icon: module.icon || '',
					label: module.name,
					prop: module.moduleId
				};
			})
			.sort((a, b) => a.sort - b.sort);

		iconGridList.value = filterGridModules;
	};

	const { goToModule } = useNavigation();
	const handleGridModule = item => {
		// 企业介绍
		if (item.prop === 'company_profile') {
			return goCompany();
		}

		const flattenModules = getIrTemplateFlattenModules.value;
		const findModule = flattenModules.find(module => {
			return module.moduleId === item.prop;
		});
		if (findModule.moduleId) {
			goToModule(findModule.moduleId);
		}
	};

	return {
		iconGridList,
		getIrCoreConfig,
		generateGridModules,
		handleGridModule
	};
}
